// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YOgx","title":"Info_title__3yYEs","links":"Info_links__2y1ol","link":"Info_link__1kpiK","logo":"Info_logo__13_St"};